<script setup lang="ts">
import type { ClientCriterion, LoadClientsForCriteria } from '../../../../types'
import CriteriaAsyncEntitySelect from '../CriteriaAsyncEntitySelect.vue'
import CriteriaFieldCell from '../CriteriaFieldCell.vue'
import { useCriterionField } from '../useCriterionField'

const props = withDefaults(
  defineProps<{
    row: ClientCriterion
    /** Absent where the host does not offer client criteria at all. */
    loadClients?: LoadClientsForCriteria
    isDisabled?: boolean
  }>(),
  { loadClients: undefined, isDisabled: false },
)
const emits = defineEmits<(e: 'update:row', row: ClientCriterion) => void>()

const client = useCriterionField(props, emits, 'client')
</script>

<template>
  <CriteriaFieldCell v-if="loadClients">
    <CriteriaAsyncEntitySelect
      v-model="client"
      :is-disabled="isDisabled"
      :load-options="loadClients"
      placeholder="Client name"
      size="large"
    />
  </CriteriaFieldCell>
</template>
